class VideoPlayerMP4 {
  constructor(props) {
    this.parent = props.parent;
    this.onReady = props.onReady || null;
    this.onComplete = props.onComplete || null;
    this.parent.innerHTML = '';
    this.video = document.createElement('video');
    this.video.style.cssText = 'position: absolute; left: 0; top: 0; width: 100%; height: 100%;';

    const playerAttributes = {
      autoplay: '',
      autoload: '',
      controls: '',
      preload: 'auto',
      playsinline: '',
      ...props.playerOptions,
    };
    Object.keys(playerAttributes).forEach((key) => {
      const value = playerAttributes[key];
      if (value !== false) {
        this.video.setAttribute(key, value === true ? '' : value);
      }
    });

    this.source = document.createElement('source');
    this.source.src = props.video;
    this.source.type = 'video/mp4';
    this.video.appendChild(this.source);

    if (props.events) {
      Object.keys(props.events).forEach((key) => {
        this.video[key] = props.events[key];
      });
    }
    this.parent.appendChild(this.video);
  }

  play() {
    if (this.video) {
      this.video.play();
    }
  }

  pause() {
    if (this.video) {
      this.video.pause();
    }
  }

  restart() {
    if (this.video) {
      this.video.currentTime = 0;
      this.video.play();
    }
  }

  destroy() {
    this.parent.innerHTML = '';
    this.video = null;
  }
}

export default VideoPlayerMP4;
